var _rect, _path, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 323,
    viewBox: "0 0 253 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 252,
    height: 321.494,
    rx: 7.5,
    fill: "url(#paint0_linear_701_9208)",
    stroke: "url(#paint1_linear_701_9208)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 267H253V312C253 317.523 248.523 322 243 322H10C4.47715 322 0 317.523 0 312V267Z",
    fill: "#BEE4FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 17.5,
    width: 209,
    height: 195,
    rx: 7.5,
    fill: "url(#paint2_radial_701_9208)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 17.5,
    width: 209,
    height: 195,
    rx: 7.5,
    stroke: "url(#paint3_linear_701_9208)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.636,
    cy: 117.363,
    r: 35.5763,
    stroke: "#C3F8DE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.636,
    cy: 117.364,
    r: 40.678,
    stroke: "#C3F8DE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 117,
    r: 45.4153,
    stroke: "#C3F8DE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 116.999,
    r: 51.2458,
    stroke: "#C3F8DE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 116.999,
    r: 57.0763,
    stroke: "#C3F8DE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.636,
    cy: 117.365,
    r: 64.7288,
    stroke: "#C3F8DE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.636,
    cy: 117.364,
    r: 73.4746,
    stroke: "#C3F8DE"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 117.002,
    r: 78.9407,
    stroke: "#C3F8DE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 117,
    r: 85.5,
    stroke: "#C3F8DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_9208",
    x1: 126.5,
    y1: 0,
    x2: 126.5,
    y2: 322.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255827,
    stopColor: "#132A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#073442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11333A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_701_9208",
    x1: 126.5,
    y1: 0,
    x2: 126.5,
    y2: 322.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50DFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_701_9208",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126 115) rotate(48.1509) scale(157.381 163.193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_701_9208",
    x1: 28.8358,
    y1: 46.299,
    x2: 282.103,
    y2: 27.3984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF1",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCard);
export default __webpack_public_path__ + "static/media/bgCard.2c56e15ebd256fd6fe7c4c5cdfd1d6ad.svg";
export { ForwardRef as ReactComponent };